/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import head from 'lodash/head';
import ContextSubMenu from 'Common/Components/ContextMenu/components/ContextSubMenu';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { selectSelected } from 'store/Contextualization/AssetDetail/selectors';
import { EditIcon } from '../styled';
import EaseOfResolution from './components/EaseOfResolution';
import ConfirmFalsePositive from './components/ConfirmFalsePositive';
import { getVulnRefs, redirectToManageDetail, setCustomAttributeField, showBulkUpdateModal, showContextMenu } from 'store/Contextualization/AssetDetail/actions';
import CustomAttributes from 'Screens/Contextualization/Manage/components/ManageTable/components/ContextMenu/components/Edit/components/CustomAttributes';

export const Edit = () => {
  const dispatch = useDispatch();
  const vulnsSelected = useSelector((state) => selectSelected('vulns', state));
  const isBulk = vulnsSelected.length > 1;
  const selectedVuln = head(vulnsSelected);
  const selectedVulnID = get(selectedVuln, '_id', null);
  const intl = useIntl();

  const goToTabDetail = (selectedTab, inputName) => {
    if (isBulk) dispatch(showBulkUpdateModal(inputName, ''));
    else if (selectedVulnID) dispatch(redirectToManageDetail(selectedVulnID, selectedTab));
    dispatch(showContextMenu(false));
  };

  const onNameEdit = () => {
    dispatch(showBulkUpdateModal('name', isBulk ? '' : selectedVuln.name));
    dispatch(showContextMenu(false));
  };
  const onExternalIdEdit = () => {
    dispatch(showBulkUpdateModal('external_id', isBulk ? '' : (selectedVuln.external_id ?? '')));
    dispatch(showContextMenu(false));
  };
  const onRefEdit = () => {
    if (isBulk) dispatch(showBulkUpdateModal('references', []));
    else dispatch(getVulnRefs(selectedVulnID));
    dispatch(showContextMenu(false));
  };
  const onImpactEdit = () => {
    const impacts = Object.keys(get(vulnsSelected, '[0].impact', {}))
      .filter((item) => get(vulnsSelected, `[0].impact.${item}`, false) === true);
    dispatch(showBulkUpdateModal('impact', isBulk ? [] : impacts));
    dispatch(showContextMenu(false));
  };
  const onPolicyEdit = () => {
    dispatch(showBulkUpdateModal('policy violations', isBulk ? [] : selectedVuln.policyviolations));
    dispatch(showContextMenu(false));
  };

  return (
    <ContextSubMenu
      icon={ <EditIcon /> }
      title={ intl.formatMessage({ id: 'manage.cm.edit' }) }
    >
      <MenuItem title={ intl.formatMessage({ id: 'manage.cm.edit.item.name' }) } onClick={ onNameEdit } />
      <MenuItem title={ intl.formatMessage({ id: 'manage.cm.edit.item.externalId' }) } onClick={ onExternalIdEdit } />
      <MenuItem title={ intl.formatMessage({ id: 'manage.cm.edit.item.data' }) } onClick={ () => goToTabDetail('technicalDetails', 'data') } />
      <MenuItem title={ intl.formatMessage({ id: 'manage.cm.edit.item.description' }) } onClick={ () => goToTabDetail('general', 'description') } />
      <MenuItem title={ intl.formatMessage({ id: 'manage.cm.edit.item.resolution' }) } onClick={ () => goToTabDetail('general', 'resolution') } />
      <MenuItem title={ intl.formatMessage({ id: 'manage.cm.edit.item.references' }) } onClick={ onRefEdit } />
      <MenuItem title={ intl.formatMessage({ id: 'manage.cm.edit.item.impact' }) } onClick={ onImpactEdit } />
      <MenuItem title={ intl.formatMessage({ id: 'manage.cm.edit.item.policyViolations' }) } onClick={ onPolicyEdit } />
      <ConfirmFalsePositive />
      <EaseOfResolution />
      <CustomAttributes vulnsSelected={ vulnsSelected } showBulkModal={ showBulkUpdateModal } showContextMenu={ showContextMenu } setCustomAttributeField={ setCustomAttributeField } />
    </ContextSubMenu>
  );
};
